import { FunctionComponent, useContext, useEffect, useState } from "react";
import { IOrderDeliveryTask } from "../../../interfaces/delivery-company/tasks";
import { Alert, Button, Chip, CircularProgress, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { displayMoney, Money } from "../../../utils/money";
import { OrderDeliveryTaskState } from "../../../enums/tasks";
import { ChangeCircle, Edit } from "@mui/icons-material";
import CustomDialog from "../custom-dialog/custom-dialog";
import MoneyInput from "../money-input/money-input";
import { API_ENDPOINT } from "../../../configurations/global.config";
import { useSnackBar } from "../../../contexts/snackbar";
import axios from "axios";
import { AuthContext } from "../../../contexts/user-context/user-context";
import UpdateCommissionDialog from "./update-commission-dialog";

interface DeliveryTaskCommissionProps {
    task: IOrderDeliveryTask,
    updateDeliveryTask: (t: IOrderDeliveryTask) => void,
    disabled?: boolean
}

const DeliveryTaskCommission: FunctionComponent<DeliveryTaskCommissionProps> = ({task, updateDeliveryTask, disabled = false}: DeliveryTaskCommissionProps) => {
    const failed = task.status ==  OrderDeliveryTaskState.FAILED
    
    const commission = failed ? task.failed_delivery_commission : task.driver_commission
    const [isEditing, setIsEditing] = useState(false)

    return <>
            <Chip
                label={` ${failed ? 'Failure' : 'Delivery'} Commission: ${displayMoney(commission)}`}
                size="small"
                variant="outlined"
                icon={<Edit />}
                disabled={task.driver_invoice != undefined || disabled}
                onClick={()=>setIsEditing(true)}
            />
            <br />
           {
            isEditing && <UpdateCommissionDialog updateDeliveryTaskCommission={(c)=>{
                failed ? updateDeliveryTask({...task, failed_delivery_commission: c}) : updateDeliveryTask({...task, driver_commission: c}) 
            }} onClose={() => setIsEditing(false)} task={task}/>
           } 
    
    </>
}
 
export default DeliveryTaskCommission;